/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommunicationType
 */
export interface CommunicationType {
    /**
     * 
     * @type {string}
     * @memberof CommunicationType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationType
     */
    displayName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunicationType
     */
    requiresAddress?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunicationType
     */
    addressType?: string;
}

/**
 * Check if a given object implements the CommunicationType interface.
 */
export function instanceOfCommunicationType(value: object): value is CommunicationType {
    return true;
}

export function CommunicationTypeFromJSON(json: any): CommunicationType {
    return CommunicationTypeFromJSONTyped(json, false);
}

export function CommunicationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommunicationType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'requiresAddress': json['requiresAddress'] == null ? undefined : json['requiresAddress'],
        'addressType': json['addressType'] == null ? undefined : json['addressType'],
    };
}

export function CommunicationTypeToJSON(json: any): CommunicationType {
    return CommunicationTypeToJSONTyped(json, false);
}

export function CommunicationTypeToJSONTyped(value?: CommunicationType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'requiresAddress': value['requiresAddress'],
        'addressType': value['addressType'],
    };
}

